import { render, staticRenderFns } from "./ListFields.vue?vue&type=template&id=5a809720&"
import script from "./ListFields.vue?vue&type=script&lang=js&"
export * from "./ListFields.vue?vue&type=script&lang=js&"
import style0 from "./ListFields.vue?vue&type=style&index=0&id=5a809720&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a809720')) {
      api.createRecord('5a809720', component.options)
    } else {
      api.reload('5a809720', component.options)
    }
    module.hot.accept("./ListFields.vue?vue&type=template&id=5a809720&", function () {
      api.rerender('5a809720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/ListFields.vue"
export default component.exports